import { useNavigate } from 'react-router-dom';

import { Query } from '../../../gql/graphql';
import useStoreManager from '../../../store/hooks/useStoreManager';
import { CacheKeys } from '../../models/utils/constants';
import useClearGraphCache from '../utils/useClearGraphCache';
import useGraphCache from '../utils/useGraphCache';
import useLogoutCurrentUser from './useLogoutCurrentUser';

const key = CacheKeys.currentUser;

const useAuth = () => {
  // hooks
  const navigate = useNavigate();
  // graphql
  const user = useGraphCache<Pick<Query, 'currentUser'>>([key])?.currentUser;
  const clearUser = useClearGraphCache([key]);
  const { logout } = useLogoutCurrentUser();
  const { onResetSession } = useStoreManager();

  const onLogout = async () => {
    try {
      const results = await logout();
      const state = results.logout?.logoutUrl;
      navigate('/auth', { state });
      // must clear cache because of routing rules
      await clearUser();
      onResetSession();
    } catch (err) {
      // do something
    }
  };

  return {
    ...user,
    authenticated: !!user,
    avatarUrl: user?.avatarUrl ?? '',
    clearUser,
    name: user?.name ?? 'No name',
    onLogout,
  };
};

export default useAuth;
